import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdviserLayout from "@/pages/adviser/AdviserLayout";
import AdviserHome from "@/pages/adviser/AdviserHome";
import AdviserLogin from "@/pages/adviser/AdviserLogin";
import AdviserInsights from "@/pages/adviser/AdviserInsights";
import AdviserBlog from "@/pages/adviser/AdviserBlog";
import AdviserPodcasts from "@/pages/adviser/AdviserPodcasts";
import AdviserPortfolios from "@/pages/adviser/AdviserPortfolios";

// Phase 3 — external adviser portal (F6). Top-level `/adviser/*` routes, imported by internal +
// adviser (NOT public). The four entitled surfaces only: insights (published), blog/commentary,
// podcasts, portfolios.
//
// Markets briefly lived here (2026-08-26) and was moved to the internal tier on 2026-08-27:
// both market surfaces are staff-only. See src/pages/partner/PartnerMarkets.tsx. All content routes carry `allowAdviser`; the ProtectedRoute adviser branch
// only grants a confirmed adviser (or a staff member falling through the normal gates).
export function adviserPortalRoutes() {
  return (
    <>
      <Route path="/adviser/login" element={<AdviserLogin />} />
      {/* Bare entry — NOT allowAdviser-gated. Where unlinked/non-adviser principals are redirected
          TO; it decides where they go next (login / dashboard / explainer). */}
      <Route
        path="/adviser"
        element={
          <ProtectedRoute>
            <AdviserHome />
          </ProtectedRoute>
        }
      />
      {/* Adviser shell — the four entitled surfaces only. allowAdviser on the shell route. */}
      <Route
        path="/adviser"
        element={
          <ProtectedRoute allowAdviser>
            <AdviserLayout />
          </ProtectedRoute>
        }
      >
        <Route path="insights" element={<AdviserInsights />} />
        <Route path="blog" element={<AdviserBlog />} />
        <Route path="podcasts" element={<AdviserPodcasts />} />
        <Route path="portfolios" element={<AdviserPortfolios />} />
      </Route>
    </>
  );
}
